<p i18n>Select an order to set a new return.</p>
<app-order-history
  actionIcon="bi bi-arrow-right"
  actionText="Select"
  i18n-actionText
  [enableActionMethod]="true"
  (actionMethod)="selectOrder($event)"
></app-order-history>
